<template>
	<!-- 资金账号管理 -->
	<div class="accont">
		<div class="title">
			<div class="name">
				<div class="padding"></div>
				资金账号设置
			</div>
		</div>
		<div class="content">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="支付宝账号" prop="ali"><el-input v-model="ruleForm.ali" placeholder="请输入支付宝账号"></el-input></el-form-item>
				<el-form-item label="微信账号" prop="wechat"><el-input v-model="ruleForm.wechat" placeholder="请输入微信账号"></el-input></el-form-item>
				<el-form-item label="对公账户" prop="adderss"><el-input v-model="ruleForm.adderss" placeholder="请输入对公账户"></el-input></el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
					<el-button @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {payConfgApi,updatePayConfgApi} from '../../http/factory/add-eme.js'
export default {
	name: 'accont',
	data() {
		return {
			ruleForm: {
				adderss: '',
				wechat: '',
				ali: ''
			},
			rules: {
				ali: [{ required: true, message: '请输入支付宝账号', trigger: 'blur' }],
				wechat: [{ required: true, message: '请输入微信账号', trigger: 'blur' }],
				adderss: [{ required: true, message: '请输入对公账户', trigger: 'blur' }]
			}
		};
	},
	created() {
		this.init()
	},
	methods: {
		init(){
			payConfgApi().then(res => {
				this.ruleForm = res
			})
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					updatePayConfgApi(this.ruleForm).then(res => {
						this.$message({
							type: 'success',
							message:'提交成功'
						})
					})
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
};
</script>

<style lang="less" scoped="scoped">
.accont {
	width: 100%;
	background: @vue-bg-color;
	padding: 0px @vue-spacing-row-lg;
	box-sizing: border-box;
}
.title {
	width: 100%;
	height: 50px;
	border-bottom: 1px solid @vue-border-color;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	.name {
		height: 100%;
		display: flex;
		align-items: center;
	}
	.padding {
		width: 4px;
		height: 16px;
		background: #ff5252;
		margin-right: @vue-spacing-row-sm;
	}
}
.content {
	width: 100%;
	padding: @vue-spacing-col-lg 0px @vue-spacing-col-lg*3 0px;
	box-sizing: border-box;
}
</style>
